import { filter } from 'lodash';
import * as t from './actionTypes';

const initialState = {
    logitems: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case t.CLEAR_CHANGELOG:
            return Object.assign({}, state, {
                logitems: []
            });
        case t.LOAD_CHANGELOG:
            return Object.assign({}, state, {
                logitems: action.payload
            });
        default:
            return state
    }
}